module.exports = __webpack_public_path__ + "static/media/logo.58769767.jpg";